import React, {useEffect} from 'react';
import {PageContainer} from './../layout';
import {Breadcrumbs} from './../layout/components';
import {TeamMemberProfile} from './components';
import {teamMembersData} from './data';
import {getPageData} from '../page/actions/pageActions.jsx';
import {compose} from 'react-recompose';
import {connect} from 'react-redux';
import { withRouter } from '../../router';
import {Link} from 'react-router';
import { MEET_OUR_TEAM_URL } from "./actions/constants.jsx";

const MeetOurTeam = ({getPageData}) => {
    const pageTitle = 'Meet and Greet PlaygroundEquipment.com Offices - PlaygroundEquipment.com';

    useEffect(() => {
        console.log('** useEffect MeetOurTeam');
        getPageData(MEET_OUR_TEAM_URL);
        document.title = pageTitle;
    }, [getPageData]);

    const breadcrumbs = [
        {
            name: 'Home',
            url: '/'
        },
        {
            name: 'About Playground Equipment.com',
            url: '/about-us/'
        },
    ]

    return (
        <PageContainer
            className='meet-our-team'
            title={pageTitle}
            metaDescription='meet, greet, about, us, PlaygroundEquipment.com'
            metaKeywords='PlaygroundEquipment.com is an easygoing Internet playground equipment supplier with decades of
            combined industry experience. Meet our staff and learn more about us.'
            canonicalUrl={MEET_OUR_TEAM_URL}
        >
            <div className="cms-container">
                <div className="meetourteam">
                    <div className="cms-header mb-3">
                        <div className="container">
                            <Breadcrumbs breadcrumbs={breadcrumbs} currentPageTitle="Meet Our Team"/>
                            <h1 className="text-center bigtitle blue">Meet Our Team</h1>
                            <div className="h3 text-center orange my-0">Click each team member’s profile below to learn more about them!</div>
                        </div>
                    </div>


                    <div className="container">
                        <p> Welcome to the heart and soul of our playground adventure – meet the extraordinary team behind the magic at PlaygroundEquipment.com, where innovation meets recreation. Each member of our team brings unique talents and perspectives to the table, fostering a collaborative environment where we thrive on challenges and celebrate the joy that exceptional playgrounds bring to communities. With 140+ dedicated individuals spread across three states, we are more than just a company; we are a community. As a united force, we walk together, side by side to tackle challenges, spark creativity, and turn dreams into reality. Get ready to embark on a journey with the dream weavers and problem solvers who propel <Link to='/'>Playgroundequipment.com</Link>  to new heights! </p>
                        <div className="team mt-4">
                            <div className="row">
                                {teamMembersData.map((profile, index) => (
                                    <TeamMemberProfile memberProfileInfo={profile} key={index}
                                                       profileIndex={index + 1}/>
                                ))}


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PageContainer>
    )
};

const reduxConnect = connect(state => {return {}}, {getPageData})

const composeHoc = compose(
    reduxConnect,
    withRouter
);

export default composeHoc(MeetOurTeam);
